export default __webpack_public_path__ + "static/media/dp-react-ts.74f4bd5a.png";